import { render, staticRenderFns } from "./TaxonomyGroup.vue?vue&type=template&id=3cd40f6e&scoped=true"
import script from "./TaxonomyGroup.vue?vue&type=script&lang=js"
export * from "./TaxonomyGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd40f6e",
  null
  
)

export default component.exports